<div class="container">




    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" *ngIf="!isAdmin">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
            <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
        </ng-container>


        <ng-container matColumnDef="application">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="application"> Application </th>
            <td mat-cell *matCellDef="let element"> {{element?.application?.ApplicationName}} </td>
        </ng-container>


        <ng-container matColumnDef="lastLogon" *ngIf="cameras.application?.ApplicationName !== 'SmartWaste'">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="lastLogon"> Dernière connexion </th>
            <td mat-cell *matCellDef="let element"> {{element?.lastLogon?.date}} </td>
        </ng-container>


        <ng-container matColumnDef="battery">
            <th mat-header-cell *matHeaderCellDef> battery
            </th>
            <td mat-cell *matCellDef="let element"> {{element.battery}}% </td>
        </ng-container>



        <ng-container matColumnDef="lastSync" *ngIf="cameras.application?.ApplicationName !== 'SmartWaste'">
            <th mat-header-cell *matHeaderCellDef class="header_infos"> Mise à jour </th>
            <td mat-cell *matCellDef="let element" class="infos">
                <fa-icon [icon]="faInfoCircle" (click)="openDialogInfoCamera(element)"></fa-icon>
            </td>
        </ng-container>



        <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef> Info </th>
            <td mat-cell *matCellDef="let element">
                <fa-icon [icon]="faInfo" (click)="openDialogOptionCamera(element)"> </fa-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <fa-icon [icon]="faCogs" (click)="openDialogAction(element)"> </fa-icon>
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>




</div>